import React, { useEffect } from "react";

import { BrowserRouter as Router } from "react-router-dom";

import { I18nProvider } from "@lingui/react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

import { setAppInfoHeader } from "@readai/common/api";
import Config from "@readai/common/config";
import Tracker from "@readai/common/tracking/Tracker";
import { USER_REQUESTED_LOCALE } from "@readai/common/utils";

import i18n, { switchLocale } from "@app/booking/locales";

import Booking from "./Booking";
import packageJSON from "../package.json";

setAppInfoHeader(packageJSON);

const queryClient = new QueryClient({
  defaultOptions: { queries: { refetchOnMount: false } },
});

Tracker.initialize({
  gaId: Config.tracking.GOOGLE_ID,
  mixpanelId: Config.tracking.MIXPANEL_ID,
  debug: Config.tracking.DEBUG,
});

const App = () => {
  useEffect(() => {
    switchLocale(USER_REQUESTED_LOCALE);
  }, []);

  return (
    <I18nProvider i18n={i18n}>
      <Router>
        <QueryClientProvider client={queryClient}>
          <Booking />
        </QueryClientProvider>
      </Router>
    </I18nProvider>
  );
};

export default App;
